var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftKeySymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.757 4.633v-1.27H3.361L5.785.94 4.908.07.978 4l3.93 3.937.877-.887-2.424-2.416h6.396z",
    fill: "currentColor"
  })));
}
export default SvgArrowLeftKeySymbol;